import React, { useEffect, useState } from 'react';
import TagCard from '../components/TagCard';
import { fetchWithCSRF } from '../utils/csrfUtils';
import { Spinner } from 'react-bootstrap';

const TagCardsSelector = ({ sessionToken, onTagClick }) => {
    const [tags, setTags] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // useEffect for API calls that need the session token
    useEffect(() => {
        if (!sessionToken) return;

        const fetchTags = async () => {
            try {
                const response = await fetchWithCSRF('/api/v1/tag/default', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch tags: ${response.status}`);
                }

                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data)) {
                    throw new Error('Invalid data format: expected an array of tags');
                }

                setTags(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching tags:', error);
                setError('Failed to load tag options');
            } finally {
                setIsLoading(false);
            }
        };

        fetchTags();
    }, [sessionToken]);

    if (isLoading) {
        return (
            <div className="text-center my-4">
                <Spinner animation="border" role="status" style={{ color: '#52cd92' }}>
                    <span className="visually-hidden">Loading tags...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-warning" role="alert">
                <p className="mb-0">{error}</p>
            </div>
        );
    }

    if (!tags.length) {
        return (
            <div className="alert alert-info" role="alert">
                <p className="mb-0">No tag options available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="tag-cards">
            <div className="tag-card-container">
                {tags.map(tag => (
                    <TagCard key={tag.id} tag={tag} onClick={onTagClick} />
                ))}
            </div>
        </div>
    );
};

export default TagCardsSelector;
